<ion-list>
  <div (click)="sendAndPutOnHold()" translate="m/task-process/send_and/put_on_hold"></div>
  <div
    *ngIf="showSurveyButton"
    (click)="sendAndTriggerSurvey()"
    translate="m/task-process/send_and/send_satisfaction_survey"></div>
  <div *ngIf="hasAtLeastOneOtherTeam" (click)="selectTeam()" translate="m/task-process/send_and/transfer_to"></div>
  <div *ngIf="canAnswerAndAskForHelp" (click)="askForHelp()" translate="m/task-process/send_and/ask-for-help"></div>
</ion-list>
